import { render } from "./Notfound.vue?vue&type=template&id=0a7d27d5&scoped=true"
import script from "./Notfound.vue?vue&type=script&lang=js"
export * from "./Notfound.vue?vue&type=script&lang=js"

import "./Notfound.vue?vue&type=style&index=0&id=0a7d27d5&scoped=true&lang=css"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7d27d5"]])

export default __exports__